import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "body-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Login = _resolveComponent("Login")!
  const _component_Dashboard = _resolveComponent("Dashboard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    (!_ctx.user.token)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Login, { loggedInCallBack: _ctx.processLogin }, null, 8, ["loggedInCallBack"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Dashboard)
          ])
        ]))
  ]))
}